<phdsoft-window [options]="optionsWindow" (ok)="submit()">

   
    <div content style="margin-top: 25px;margin-left:15px; height: 50px;">
               <!-- <fieldset
                   style="margin-top: 25px; border-color:white; width:250px;height:60px;border:solid 1px;border-radius:20px;">
                   -->
                   <button (click)="toggleShow()" mat-raised-button style="margin-left: 60px;margin-top: 12px;">
                       <mat-icon>miscellaneous_services</mat-icon>
                       Advanced
                   </button>
                   
                                         
               <!-- </fieldset> -->
   </div>  
   
   <div content *ngIf="isShown">
       

               <!-- <table style="margin-top: 10px;">
                   <tr>
                       <td>
                           <mat-icon style="margin-left: 60px; ">chevron_left</mat-icon>
                       </td>
                       <td>
                           <mat-label style="margin-left: 25px; margin-top: 7px;font-size:11px;"> 1 of 5
                           </mat-label>
                       </td>
                       <td>
                           <mat-icon style="margin-left: 20px;">chevron_right</mat-icon>

                       </td>
                   </tr>
               </table> -->

               <div style="display: flex;flex-direction: column; height: 100%;">
                   <div style="overflow-x: hidden; overflow-y: auto;">
                       <mat-label style="margin-left: 85px; margin-top: 5px;">General Setting's</mat-label>
                       <phdsoft-region-select [Regions]="_AutomaticPoints.GeneralSettings.Regions"
                           (SelectRegion)="onSelectRegion($event)" (SelectSection)="onSelectSection($event)">
                       </phdsoft-region-select>

                   </div>                 


               </div>


           
      
   </div>
</phdsoft-window>
